<template>
  <div class="asHeaderVideo">
    <slot />
  </div>
</template>

<style lang="scss">
@import '@web/assets/scss/vars.scss';

.asHeaderVideo {
  position: relative;

  background-image: linear-gradient(77deg, #3e62f9 0%, #b03ffb 100%);

  &::before {
    content: attr(data-id);

    position: absolute;
    top: 50%;
    left: 0;
    right: 0;

    transform: translateY(-50%);

    font-size: 60px;
    color: rgba(255, 255, 255, .5);
    text-align: center;

    pointer-events: none;
  }

  &_video {
    position: relative;

    display: block;
    width: 100%;
    padding-top: 56.25%;

    overflow: hidden;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      border: 0;

      height: 100%;
      width: 100%;
    }
  }
}
</style>
